import { de } from "@ainkauf/core";

/** Wortmarke: "AI" in der Akzentfarbe, der Rest in Textfarbe. */
export function Wordmark({ className = "" }: { className?: string }) {
  const rest = de.app.name.slice(2);
  return (
    <span className={`font-display font-extrabold tracking-tight ${className}`}>
      <span className="text-accent">AI</span>
      <span className="text-ink">{rest}</span>
    </span>
  );
}
